import { useTranslation } from "react-i18next";
import "./Footer.scss";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <p>
        © {year} CODACO ELECTRONIC s.r.o. |{" "}
        {t(["footer.credit", "footer_credit"])}
      </p>
    </footer>
  );
}
